import type { TaxonomyEntry } from '~/models/TaxonomyEntry'
import { contentClient } from '~/api/client/contentClient'

export default function useTaxonomyApi() {
  const getTaxonomyEntriesByParentContentId = (parentContentId: number) =>
    contentClient.get<TaxonomyEntry[]>(`/search/taxonomy/children`, {
      params: { parentId: parentContentId },
    }).then(response => response.data)

  return {
    getTaxonomyEntriesByParentContentId,
  }
}
